import { detailSliceActions } from "./detailsSlice"

export const detailActions = {
    ...detailSliceActions
}
